export enum CERStatus {
  DRAFT = "draft",
  TO_SIGN = "toSign",
  TO_SIGN_MANAGER = "toSignManager",
  TO_SIGN_CANDIDATE = "toSignCandidate",
  TO_SIGN_PAPER = "toSignPaper",
  SIGNED = "signed",
  SIGNED_PAPER = "signedPaper",
  TO_VALIDATE_MANAGER = "toValidateManager",
  REFUSED_MANAGER = "refusedManager",
}
